module.exports = __webpack_public_path__ + "img/rectangle.9f25e56f.png";